import {
  KoButton, KoDescription, KoModal, KoText, KoTitle, KoForm,
  KoFormBuilder,
  Checkbox,
  KoNano,
  KoToast,
  KoLoader,
  KoTooltips
} from 'packages';
import KoIcon from '@kwapio/icons';
import React, { useState, useEffect } from 'react';
import { adminConsoleAPI } from '../admin.service';
import styles from './appintgarions.module.scss';

export default function AppIntgarions() {
  const [isOpen, setModal] = useState(false);
  const [appSettings, setAppSettings ] = useState({});
  const [form] = KoForm.useForm();
  const [isLoading, setLoading] = useState(false);
  const [platform, setPlatform] = useState();
  const [connectedPlatforms, setConnectedPlatforms] = useState([]);

  useEffect(() => {
    getPlatform();
  }, []);

  const getPlatform = () => {
    setLoading(true);
    adminConsoleAPI.getPlatform().then(
      (data) => {
        setPlatform(data?.platforms);
        setLoading(false);
        setConnectedPlatforms(data?.platforms.map(p => p.platform));
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleClick = (app) => {
    setLoading(true);
    adminConsoleAPI.deletePlatform(app.platformId).then(
      (data) => {
        KoToast.success('Connection revoked successfully');
        setLoading(false);
        getPlatform();
      },
      (err) => {
        setLoading(false);
      }
    );
  };


  const handleConnectApps = (app) => {
    setAppSettings(app);
    adminConsoleAPI.connectOauth(app?.key === 'gmeet' ? 'google' : app?.key).then(
      (data) => {
        KoToast.success('Conneted successfully');
        setLoading(false);
        if(data?.auth_url){
          window.open(data?.auth_url, '_blank');
        }
        getPlatform();
      },
      (err) => {
        setLoading(false);
      }
    );
  };


  const CheckBox = ({ value, onChange }) =>
    <Checkbox checked={value} onChange={v => onChange(v?.target?.checked)}>{`Enable`}</Checkbox>;


  const APPS = [
    {
      name: 'Zoom',
      icon: 'ZoomFilled',
      description: 'Schedule and join meetings',
      key: 'zoom',
      fields: [
        { key: 'config.accountId', label: 'Account ID', placeholder: 'Enter account ID', colSpan: 3, rules: [{ required: true, message: 'Enter Account ID' }] },
        { key: 'config.clientId', label: 'Client ID', placeholder: 'Enter Client ID', colSpan: 3, rules: [{ required: true, message: 'Enter Client ID' }] },
        { key: 'config.clientSecret', label: 'Secret ID', placeholder: 'Enter Secret ID', colSpan: 3, rules: [{ required: true, message: 'Enter Secret ID' }] },
        {
          key: 'isDefault',
          colSpan: 3,
          label: 'Enable as default',
          widget: CheckBox
        }
      ]
    },
    {
      name: 'Microsoft Teams',
      icon: 'MicrosoftTeamsFilled',
      key: 'teams',
      description: 'Schedule and join meetings'
    },
    {
      name: 'Google Meet',
      key: 'gmeet',
      icon: 'GoogleMeetFilled',
      description: 'Schedule and join meetings'
    }
  ];

  const handleSubmit = (values) => {
    setLoading(true);
    values['platformId'] = KoNano('PLD');
    values['platform'] = appSettings.key;
    adminConsoleAPI.createOrUpdatePlatform(values).then(
      (data) => {
        KoToast.success('Updated successfully');
        form.resetFields();
        setLoading(false);
        getPlatform();
        setModal(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const setDefaultOne = (values) => {
    setLoading(true);
   
    values['isDefault'] = true;
    adminConsoleAPI.createOrUpdatePlatform(values, values?.platformId).then(
      (data) => {
        KoToast.success('Updated successfully');
        form.resetFields();
        setLoading(false);
        getPlatform();
      },
      (err) => {
        setLoading(false);
      }
    );
  };


  let meta = {
    columns: 6,
    formItemLayout: null,
    initialValues: {},
    fields: [
      { key: 'config.accountId', label: 'Account ID', placeholder: 'Enter account ID', colSpan: 3, rules: [{ required: true, message: 'Enter Account ID' }] },
      { key: 'config.clientId', label: 'Client ID', placeholder: 'Enter Client ID', colSpan: 3, rules: [{ required: true, message: 'Enter Client ID' }] },
      { key: 'config.clientSecret', label: 'Secret ID', placeholder: 'Enter Secret ID', colSpan: 3, rules: [{ required: true, message: 'Enter Secret ID' }] },
      {
        key: 'isDefault',
        colSpan: 3,
        label: 'Enable as default',
        widget: CheckBox
      }
    ]
  };

  return (
    <div className={styles.wrapper}>
      <KoTitle text={'App Integrations'} level={4} />
      {/* <KoText text={'Connect with Zoom, Microsoft Teams, Google Meet, and more.'} className={styles.text} /> */}

      <div className={styles.content}>
        {platform?.length > 0 && <KoTitle text={'Connected'} level={4} />}
        {platform?.length > 0 && <div className={styles.meetingApps}>
          {platform?.map((platform, index) => {
            const app = APPS.find(app => app.key === platform.platform);
            if (!app) return null;

            return (
              <div className={styles.app} key={index}>
                <div className={styles.appWrapper}>
                  <KoIcon name={app.icon} width={45} height={45} />
                  <div className={styles.appTextWrapper}>
                    <KoText text={app.name} className={styles.appText} />
                    <KoDescription text={`Linked with account`} className={styles.desc} />
                  </div>
                </div>
                <div className={styles.footerGrid}>
                  {platform.isDefault ? <KoButton text={'Default'} type={'primary'} size={'small'} className={styles.appBtnCircle} /> :
                    <KoButton onClick={() => setDefaultOne(platform)} text={'Make Default'} type={'primary'} size={'small'} className={styles.appBtnCircle} />}
                  <KoTooltips title={'Revoke connection'}>
                    <KoButton
                      onClick={() => handleClick(platform)}
                      text="Revoke"
                      iconBtn
                      icon={<KoIcon name={'DeleteOutlined'} />}
                    />
                  </KoTooltips>
                </div>
              </div>
            );
          })}
        </div>}

        <KoTitle text={'Connect apps'} level={4} className={styles.titlePlatform} />
        <div className={styles.meetingApps}>
          {APPS.filter(app => !connectedPlatforms.includes(app.key)).map((app, index) => (
            <div className={styles.app} key={index}>
              <div className={styles.appWrapper}>
                <KoIcon name={app.icon} width={45} height={45} />
                <div className={styles.appTextWrapper}>
                  <KoText text={app.name} className={styles.appText} />
                  <KoDescription text={app.description} className={styles.desc} />
                </div>
              </div>
              <div className={styles.footer}>
                <KoButton
                  onClick={() => handleConnectApps(app)}
                  text={'Connect'}
                  type={'primary'}
                  size={'small'}
                  className={styles.appBtn}
                />
              </div>
            </div>
          ))}
        </div>

      </div>
      <KoModal title={appSettings.name}
        open={isOpen}
        centered
        width={700}
        handleOk={() => { setModal(false); }}
        onClose={() => { setModal(false); }}
        footer={[
          <KoButton key='cancel' label='Close' onClick={() => setModal(false)} />,
          <KoButton key='submit' label='Save' type='primary' onClick={() => form.submit()} />
        ]} >
        <div className={styles.formWrapper}>
          {isLoading && <KoLoader />}
          <KoForm form={form} layout="vertical" onFinish={handleSubmit}>
            <KoFormBuilder form={form} meta={meta} />
          </KoForm>
        </div>
      </KoModal>
    </div>
  );
}
